import React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import rehypeRaw from 'rehype-raw'
import { ImageMediaContent, LongText, RichText } from "./strapi-model";
import { extractImageInfo, resolveMediaUrl } from "./strapi-api";

export class LongTextContent extends React.Component<{ content: LongText | null; className?: string; }> {
  render() {
    return <div style={{ whiteSpace: "pre" }} className={this.props.className}>{this.props.content ?? ""}</div>
  }
}

export class RichTextContent extends React.Component<{ content: RichText | null; className?: string; }> {
  render() {
    return (
      <ReactMarkdown plugins={[gfm]} rehypePlugins={[rehypeRaw]} className={this.props.className}
                     children={this.props.content ?? ""} />
    );
  }
}

export class ImageContent extends React.Component<{ content: ImageMediaContent; }> {
  render() {
    return <img {...extractImageInfo(this.props.content)} />
  }
}

export class BackgroundedImage extends React.Component<{ content: ImageMediaContent; divClassName?: string; }> {
  render() {
    return (
      <React.Fragment>
        <div className={this.props.divClassName}
             style={{ backgroundImage: `url(${resolveMediaUrl(this.props.content)})` }}>
          {this.props.children}
          <ImageContent content={this.props.content} />
        </div>
      </React.Fragment>
    )
  }
}
